import { useFlags } from 'launchdarkly-react-client-sdk';

import Pill from './Pill';
import { getAssetSaleInfo } from 'utilities/helpers';

const AssetSalePill = ({ account }) => {
  const { showSecondAssetSaleTag } = useFlags();

  const { assetSaleTagDisplay, creditorDisplay } = getAssetSaleInfo(
    account,
    showSecondAssetSaleTag,
  );

  return assetSaleTagDisplay || creditorDisplay ? (
    <Pill data-testid="account-creditor" color="orange">
      Creditor: {assetSaleTagDisplay || creditorDisplay}
    </Pill>
  ) : undefined;
};

export default AssetSalePill;
